<template>
  <div id="Software" class="container">
    <div class="row">
      <div id="left" class="col-md-4 col-xs-12">
        <ServiceList
          :title="'解决方案'"
          :items="softwareList"
          :activeIndex="active"
          @tab-change="changeTab"
        />
        <!-- <ul class="left-container wow bounceInLeft">
          <p>解决方案</p>
          <li
            v-for="(item, index) in softwareList"
            :class="active == index ? 'active' : ''"
            :key="index"
          >
            <router-link
            @click="changeTab(index)" :to="item.path">{{ item.name }}</router-link>
          </li>
        </ul> -->
      </div>
      <div
        id="right"
        class="col-md-8 col-xs-12 wow bounceInRight"
        @touchstart="onTouchStart"
        @touchend="onTouchEnd"
      >
        <router-view></router-view>
        <div class="swipe-pager">
          <button
            type="button"
            class="pager-btn"
            :disabled="active <= 0"
            @click="goPrev"
          >
            <span class="pager-ico">&#8249;</span> 上一个
          </button>
          <span class="pager-count">{{ active + 1 }} / {{ softwareList.length }}</span>
          <button
            type="button"
            class="pager-btn"
            :disabled="active >= softwareList.length - 1"
            @click="goNext"
          >
            下一个 <span class="pager-ico">&#8250;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import ServiceList from "@/components/ServiceList.vue";
export default {
  name: "Software",
  components: {
    ServiceList,
  },
  data() {
    return {
      softwareList: [
        {
          path: "/Solution/Solution1",
          name: "智慧医疗 – 互联网+医疗数据服务运营解决方案",
        },
        {
          path: "/Solution/Solution3",
          name: "智慧医疗 – 医疗设备全生命周期管理解决方案",
        },
        {
          path: "/Solution/Solution4",
          name: "智慧医疗 – 资产精准盘点清查解决方案",
        },
        {
          path: "/Solution/Solution6",
          name: "公共卫生 – 区域传染病监测预警与应急指挥信息解决方案",
        },
        {
          path: "/Solution/Solution8",
          name: "电子政务 – 政务信息资源体系全员人口库解决方案",
        },
        {
          path: "/Solution/Solution9",
          name: "电子政务 – 紧密型县域医共体解决方案",
        },
        {
          path: "/Solution/Solution10",
          name: "数字企业 – 全链条物流、仓储管理解决方案",
        },
        {
          path: "/Solution/Solution12",
          name: "数字企业 – 停充一体化监管与服务解决方案",
        }
      ],
      active: 0,
      touchX: 0,
      touchY: 0,
    };
  },
  watch: {
    // 监听到路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.path) {
          this.softwareList.forEach((element, index) => {
            if (element.path == this.$route.path) {
              this.active = index;
            }
          });
        }
      },
    },
  },
  methods: {
    changeTab(i) {
      this.active = i;
    },
    // ---- 移动端左右滑动切换产品 ----
    onTouchStart(e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      this.touchX = e.changedTouches[0].clientX;
      this.touchY = e.changedTouches[0].clientY;
    },
    onTouchEnd(e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - this.touchX;
      var dy = e.changedTouches[0].clientY - this.touchY;
      // 横向位移足够大且明显大于纵向，避免与纵向滚动冲突
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) {
          this.goNext();
        } else {
          this.goPrev();
        }
      }
    },
    goPrev() {
      if (this.active > 0) this.goTo(this.active - 1);
    },
    goNext() {
      if (this.active < this.softwareList.length - 1) this.goTo(this.active + 1);
    },
    goTo(i) {
      if (i < 0 || i >= this.softwareList.length) return;
      this.active = i;
      this.$router.push(this.softwareList[i].path);
      this.scrollToContent();
    },
    scrollToContent() {
      this.$nextTick(function () {
        var el = document.getElementById("right");
        if (el) {
          var y = el.getBoundingClientRect().top + window.scrollY - 70;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: "smooth" });
        }
      });
    },
  },
  created() {},
  mounted() {
    var wow = new WOW();
    wow.init();
  },
};
</script>
<style scoped>
#left {
  margin: 50px 0;
}
.active {
  background-color: #474747;
}
.active a {
  color: #fff !important;
}
.left-container {
  width: 80%;
  margin: 0 auto;
  border: 1px solid #474747;
  border-radius: 5px;
}
.left-container > p {
  text-align: center;
  line-height: 45px;
  padding: 0;
  margin: 0;
  background: #474747;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}
.left-container > li {
  text-align: left;
  padding-left: 10px;
  height: 38px;
  line-height: 38px;
  margin: 0;
  border-top: 1px solid #474747;
}
.left-container > li > a {
  text-decoration: none;
}
.left-container > li:hover {
  background: #928989;
}
#right {
  padding: 50px 0;
}
@media screen and (max-width: 768px) {
  #right {
    padding: 15px;
  }
  .left-container {
    width: 90%;
    margin: 0 auto;
    border: 1px solid #474747;
    border-radius: 5px;
  }
}
/* 移动端：隐藏左侧方案切换竖列表，改为内容区左右滑动切换 + 底部分页控件（桌面端不显示） */
.swipe-pager {
  display: none;
}
@media screen and (max-width: 768px) {
  #left {
    display: none;
  }
  .swipe-pager {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
  .swipe-pager .pager-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 1;
    color: #18212e;
    background: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    transition: all 0.25s ease;
  }
  .swipe-pager .pager-btn:not(:disabled):active {
    color: #fff;
    background: #e6004c;
    border-color: #e6004c;
  }
  .swipe-pager .pager-btn:disabled {
    opacity: 0.4;
  }
  .swipe-pager .pager-count {
    font-size: 13px;
    font-weight: 600;
    color: #8a8f99;
  }
  .swipe-pager .pager-ico {
    font-size: 18px;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Solution.vue